var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video grid grid__base" }, [
    _c("div", { staticClass: "video-container grid--container" }, [
      _c("div", { staticClass: "video--row grid--row" }, [
        _c("div", { staticClass: "video--col grid--col" }, [
          _c("div", { staticClass: "video--iframe-wrapper" }, [
            _c("iframe", {
              staticClass: "video--iframe",
              attrs: {
                allow: "encrypted-media",
                allowfullscreen: "",
                "data-cookieblock-src": _vm.url,
                "data-cookieconsent": "marketing"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "cookieconsent-optout-marketing" }, [
              _vm._v(
                "\n                        " +
                  _vm._s(_vm.text) +
                  "\n                        "
              ),
              _c("a", { attrs: { href: "javascript:Cookiebot.renew()" } }, [
                _vm._v(" Cookies")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f739d0", { render: render, staticRenderFns: staticRenderFns })
  }
}